import React from "react";
import PropTypes from "prop-types";
import { CustomLink } from "../../custom-link";
import { MediaObject } from "../../basic/media-object-list.js";
import { AdService } from "../../ad-service";
import "./fullscreen-media-list.m.css";

function FullscreenMediaList(props) {
  const mediaObjectConfig = {
    section: !props.hideSectionName,
    enlarged: true,
    noBackground: true,
    storyTime: true,
    aspectRatio: [5, 3]
  };

  const { limit } = props;

  if (props.stories.length < 1) {
    return <div />;
  }

  return (
    <div data-test-id="list-component">
      <div className="search-story-wrapper">
        <div>
          {props.stories.slice(0, 3).map((storyObj = {}, index) => {
            const story = storyObj && storyObj.story ? storyObj.story : storyObj;
            return (
              <div
                styleName="list-object"
                data-testid={`list-object-${index}`}
                data-load-more-object="true"
                key={story.id}
              >
                <MediaObject story={story} config={mediaObjectConfig} sectionColor={props.config["collection-color"]} />
              </div>
            );
          })}
          <div className="app-ad app-ad--story-horizontal">
            <AdService adtype="Story-Middle-Ad" slotId={`FullscreenMediaList-${props.index}`} />
          </div>
          {props.stories.slice(3, limit).map((storyObj = {}) => {
            const story = storyObj && storyObj.story ? storyObj.story : storyObj;
            return (
              <div styleName="list-object" data-load-more-object="true" key={story.id}>
                <MediaObject story={story} config={mediaObjectConfig} sectionColor={props.config["collection-color"]} />
              </div>
            );
          })}
          {!props.hideLoadmore && (
            <div className="load-more" data-test-id="full-screen-media-list-loadmore">
              {props.getMoreStories ? (
                <button data-test-id="load-more" onClick={props.getMoreStories}>
                  Load More
                </button>
              ) : (
                <CustomLink href={"/" + props.config["collection-slug"]}>Read more</CustomLink>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

FullscreenMediaList.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.array,
  collection: PropTypes.object,
  hideSectionName: PropTypes.bool,
  hideLoadmore: PropTypes.bool,
  getMoreStories: PropTypes.func,
  adSlot: PropTypes.bool,
  limit: PropTypes.number,
  index: PropTypes.number
};

export { FullscreenMediaList };
